import { useMemo } from "react";
import { Control, Controller } from "react-hook-form";
import { useGetArticlesList, useGetPriceList } from "shared-apis";

import { TimePicker } from "components/TimePicker";
import { VerticalSpace } from "components/VerticalSpace/VerticalSpace";
import { NamedInput } from "components/NamedInput/NamedInput";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";
import { NamedSelect } from "components/NamedSelect/NamedSelect";
import { BorderedContainer } from "components/BorderedContainer/BorderedContainer";
import { MediumText } from "components/MediumText/MediumText";
import RadioButton from "components/Radio/Radio";
import { VerticalPadding } from "components/VerticalPadding/VerticalPadding";
import { Checkbox2 } from "components/Checkbox2/Checkbox2";
import { Paragraph } from "components/Paragraph/Paragraph";

import styles from "../styles.module.scss";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import { USER_CALC_TYPE_CONSTANTS, FromShopValues } from "../NewShop";

type Props = {
  control: Control<FromShopValues>;
  isEdit: boolean;
};

export const NewShopBody = ({ control, isEdit }: Props): JSX.Element => {
  const { data: priceList = [] } = useGetPriceList();
  const { data: articleList = [] } = useGetArticlesList({});

  const priceListOptions = useMemo(() => {
    return priceList.map((option: any) => ({
      value: option.pricelistid,
      label: option.name,
    }));
  }, [priceList]);

  const articleListOptions = useMemo(() => {
    return articleList.map((option: any) => ({
      value: option.articleid,
      label: option.name,
    }));
  }, [articleList]);

  return (
    <div className={styles.container}>
      <VerticalSpace size={19} />
      <div className="flex gap-x-7">
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <NamedInput
              {...field}
              label="Название"
              placeholder="Новый магазин"
              type="text"
              isRequired
              isLabelRegular
              onChange={(e) => {
                field.onChange(e);
              }}
              className={styles.name_input}
            />
          )}
        />
        {isEdit && (
          <Controller
            name="storesid"
            control={control}
            render={({ field }) => (
              <NamedInput
                {...field}
                label="Код"
                placeholder="13"
                type="number"
                disabled
                isLabelRegular
                isRequired
                onChange={(e) => {
                  field.onChange(e);
                }}
                className={styles.code_input}
              />
            )}
          />
        )}
      </div>
      <VerticalSpace size={12} />
      <div>
        <Controller
          name="selectedPricelistItem"
          control={control}
          render={({ field }) => (
            <NamedSelect
              {...field}
              name="Прайс лист"
              nameClassName={styles.selectLabel}
              placeholder={"Выберите прайслист"}
              options={priceListOptions}
            />
          )}
        />
      </div>
      <VerticalSpace size={12} />
      <div>
        <Controller
          name="selectedArticleListItem"
          control={control}
          render={({ field }) => (
            <NamedSelect
              {...field}
              name="Статья затрат при продаже"
              nameClassName={styles.selectLabel}
              placeholder={"Выберите статью затрат"}
              options={articleListOptions}
            />
          )}
        />
      </div>
      <VerticalSpace size={25} />
      {/*<BorderedContainer className={styles.wrapper}>
        <MediumText>Расчёт зарплаты сотрудников</MediumText>
        <VerticalSpace size={15} />
        <div style={{ marginBottom: "8px" }}>
          {USER_CALC_TYPE_CONSTANTS.map((employeeGetItem: any) => (
            <VerticalPadding padding={8} key={employeeGetItem.value}>
              <Controller
                name="usercalctype"
                control={control}
                render={({ field }) => (
                  <RadioButton
                    id={employeeGetItem.value}
                    text={employeeGetItem.name}
                    name={"usercalctype"}
                    onChange={() => {
                      const newValue = USER_CALC_TYPE_CONSTANTS.find(
                        (item) => item.value !== field.value
                      )?.value;

                      field.onChange(newValue);
                    }}
                    checked={field.value === employeeGetItem.value}
                    value={field.value}
                  />
                )}
              />
            </VerticalPadding>
          ))}
          <VerticalPadding padding={8} className="flex items-center">
            <Controller
              name="useroperationforpercent"
              control={control}
              render={({ field }) => (
                <Checkbox2
                  checked={!!field.value}
                  onChange={() => {
                    field.onChange(!field.value);
                  }}
                />
              )}
            />
            <HorizontalSpace size={13} />
            <Paragraph>Совершить кассовую операцию</Paragraph>
          </VerticalPadding>
          <VerticalPadding padding={8} className="flex items-center">
            <Controller
              name="usergetpercentbyplan"
              control={control}
              render={({ field }) => (
                <Checkbox2
                  checked={!!field.value}
                  onChange={() => {
                    field.onChange(!field.value);
                  }}
                />
              )}
            />
            <HorizontalSpace size={13} />
            <Paragraph>Начислять % при выполнении плана продаж</Paragraph>
          </VerticalPadding>
        </div>

        <div className="flex gap-x-5">
          <Controller
            name="nightopentimeafter"
            control={control}
            render={({ field }) => (
              <TimePicker
                {...field}
                onChange={(newValue: any) => {
                  field.onChange(newValue);
                }}
                label="Время"
              />
            )}
          />
          <Controller
            name="dayopentimeafter"
            control={control}
            render={({ field }) => (
              <TimePicker
                {...field}
                onChange={(newValue: any) => {
                  field.onChange(newValue);
                }}
                label="Начало дневной смены"
              />
            )}
          />
        </div>
      </BorderedContainer>*/}
    </div>
  );
};
